module.exports = __webpack_public_path__ + "d8458b6cbd04c7e8fcd08831f8c453c9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-arrow-down-solid.svg
// module id = Mjho
// module chunks = 5